import PostItsIcon from './PostItsIcon'

export default PostItsIcon
